import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useOverlayContext } from 'seagull';
import { useAnalystChatStore } from '~/components/ai/AnalystAgentPane/store/analystChatStore';
import { routes } from '~/constants';
import { useIoContext, useStoreActions, useStoreStatic } from '~/contexts';
import { useSetAuthToken } from '~/hooks/useSetAuthToken';
import { useLocaleKeys } from '~/i18n';
import { useHomePage } from '~/pages/HomePage/HomePageProvider';
import { queryClient } from '~/queryClient';
export function useSwapAuthToken() {
    const navigate = useNavigate();
    const { t: commonTexts } = useLocaleKeys('common');
    const { showErrorToast } = useOverlayContext();
    const { resetBusinessData } = useStoreActions();
    const { getState } = useStoreStatic();
    const { cookies } = useIoContext();
    const setAuthToken = useSetAuthToken();
    const { setHidden } = useHomePage();
    return useCallback(async (authToken, options)=>{
        setHidden(true);
        resetBusinessData();
        useAnalystChatStore.getState().reset();
        try {
            if (getState().session.useAuthorizationHeader) {
                cookies.setAuthTokenForNative(authToken);
            }
            queryClient.clear();
            await setAuthToken(authToken);
            // WHY: setAuthToken awaits outgoing-business fetches that write after the first clear (ANCR-4722).
            queryClient.clear();
            navigate((options === null || options === void 0 ? void 0 : options.route) || routes.home, {
                replace: true
            });
        } catch (unused) {
            showErrorToast(commonTexts.toasts.failedToSwitchBusiness(), 'swap-auth-token-failure');
            navigate(routes.logout);
        } finally{
            setHidden(false);
        }
    }, [
        setAuthToken
    ]);
}
